<template>
    <!-- Header com logo e título -->
     <div>
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
      <v-col cols="3">
        <v-img
          src="@/assets/logo_delta.jpg"
          contain
          height="90"

        />
      </v-col>
      <v-col cols="9" class="text-right">
        <h2 class="mb-0">Job's Abertos</h2>
        <h3>Geral</h3>
        <!-- <small><strong>Entre</strong> 01/01/2024 a 31/12/2024</small> -->
      </v-col>
    </div>

    <!-- Tabela de dados -->
    <v-simple-table dense>
        <thead>
            <tr>
                <th>CÓD./PED</th>
                <th>Abertura</th>
                <th>Encerramento</th>
                <th>Cliente/Descrição</th>
                <th>Vend/Coord</th>
                <th>Valor Job</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="dado in data" :key="dado._id">
                <template v-if="!dado.revisoes">
                    <td style="padding: 20px" width="100"><strong>{{ dado.code }}</strong> / {{ dado.pedidoCompra }}</td>
                    <td>
                        {{ dado.dataAbertura ? new Date(dado.dataAbertura).toLocaleDateString() : '' }}
                    </td>
                    <td>
                        {{ dado?.dataEncerramento ? new Date(dado?.dataEncerramento || '').toLocaleDateString() : '' }}
                    </td>
                    <td>
                        {{ dado.clienteNome || "Cliente Não Informado" }} <br /> / {{ dado.description }}
                    </td>
                    <td>-</td>
                    <td>
                        {{  Number(dado.valorJob).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}}
                    </td>
                </template>

                <template v-else>
                    <td style="padding: 20px"><strong>{{ dado.code }}</strong> / {{ dado.revisoes.pedidoCompra }}</td>
                    <td>
                        {{ dado.revisoes.dataAbertura ? new Date(dado.revisoes.dataAbertura).toLocaleDateString() : '' }}
                    </td>
                    <td>
                        {{ dado.revisoes?.dataEncerramento ? new Date(dado.revisoes?.dataEncerramento || '').toLocaleDateString() : ''}}
                    </td>
                    <td>
                        {{ dado.revisoes.clienteNome || "Cliente Não Informado" }} <br /> / {{ dado.revisoes.description }}
                    </td>
                        <td>-</td>
                    <td>
                        {{ Number(dado.valorJob).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }) }}
                    </td>
                </template>
            </tr>
        </tbody>
    </v-simple-table>
    <footer class="w-100 d-flex justify-end">
        <span>
            <strong> Total de Jobs: {{ this.data.length }} Totalizados - </strong> 
            {{ sumJobs() }}
        </span>
    </footer>
</div>
</template>

<script>
export default {
    name: 'JobPdfView',
    props: ['data'],
    data() {
        return {
        };
    },
    methods: {
        sumJobs() {
            return this.data.reduce((acc, valor) => {
                return acc + Number(valor.valorJob)
            }, 0).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })
        },
    },
};
</script>

<style scoped>
h2 {
  font-weight: bold;
}
.v-simple-table th,
.v-simple-table td {
  font-size: 9px;
  padding: 6px 8px;
  vertical-align: top;
}
</style>
